"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _withContainer = require("./withContainer");

var _withContainer2 = _interopRequireDefault(_withContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgVirtualVisitInverted = function SvgVirtualVisitInverted(props) {
    return _react2.default.createElement(
        "svg",
        Object.assign({ width: "1em", height: "1em", viewBox: "0 0 32 32" }, props),
        _react2.default.createElement(
            "g",
            { transform: "translate(0 7)", fill: "currentColor", fillRule: "nonzero" },
            _react2.default.createElement("rect", { x: 0.72, y: 0.24, width: 21.85, height: 17.53, rx: 2.09 }),
            _react2.default.createElement("path", { d: "M31.28 15.63l-6.46-3.44V5.81l6.46-3.44z" })
        )
    );
};

exports.default = (0, _withContainer2.default)(SvgVirtualVisitInverted);